var map = {
	"./music-instructions.json": 5297,
	"./music-library-intro2024.json": 5298,
	"./music-library-launch2024.json": 5299,
	"./music-progression.json": 5300,
	"./startSourcesAdvanced.json": 5301,
	"./startSourcesSimple.json": 5302,
	"./startSourcesSimple2.json": 5303,
	"./startSourcesTracks.json": 5304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4903;